import React from 'react';
import { HistoryGrid } from '@1823-partners/core';
import { getBrokerEntryHistory } from '../api';

const BrokerHistory = ({ broker, priceFile }) => (
  <HistoryGrid
    fetchHistory={() => getBrokerEntryHistory(priceFile, broker)}
    fetchParams={[priceFile, broker]}
    fieldNames={{
      BROKER: 'Broker', CUSIPS: 'CUSIPs', PRICE_FILE: 'Price File',
      EMAIL: 'Email', SUBJECT: 'Subject', SECURITY_LIST: 'Security List',
      ADDITIONS: 'Additions', STATUS: 'Status', SOURCE: 'Source',
    }}
    columns={[
      { field: 'BROKER', headerName: 'Broker', pinned: 'left' },
      { field: 'CUSIPS', headerName: 'CUSIPs' },
      { field: 'PRICE_FILE', headerName: 'Price File' },
      { field: 'EMAIL', headerName: 'Email' },
      { field: 'SUBJECT', headerName: 'Subject' },
      { field: 'SECURITY_LIST', headerName: 'Security List' },
      { field: 'ADDITIONS', headerName: 'Additions' },
      { field: 'STATUS', headerName: 'Status' },
      { field: 'SOURCE', headerName: 'Source' },
    ]}
  />
);

export default BrokerHistory;
